import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
const videos = [{
  title: 'Master Bathroom Transformation',
  duration: '3:45',
  thumbnail: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Kitchen Remodeling Process',
  duration: '5:20',
  thumbnail: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Addition & Outdoor Terrace',
  duration: '4:15',
  thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function Videos() {
  return <section className="py-24 bg-primary text-white" data-id="element-277">
      <div className="container mx-auto px-6 md:px-12" data-id="element-278">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-279">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-280">
            <h2 className="text-accent font-medium tracking-widest uppercase text-sm mb-3" data-id="element-281">
              In Action
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-282">
              Videos of Our Work
            </h3>
            <p className="text-gray-300 text-lg" data-id="element-283">
              Join us in the day-to-day of our projects and see firsthand the
              dedication and professionalism of our team.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-284">
          {videos.map((video, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group cursor-pointer" data-id="element-285">
              <div className="relative aspect-video rounded-sm overflow-hidden mb-4 bg-gray-800" data-id="element-286">
                <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-287" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-288">
                  <div className="w-16 h-16 bg-accent/90 text-white rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300" data-id="element-289">
                    <Play fill="currentColor" size={24} className="ml-1" data-id="element-290" />
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-sm font-medium" data-id="element-291">
                  {video.duration}
                </div>
              </div>
              <h4 className="text-xl font-serif font-bold group-hover:text-accent transition-colors" data-id="element-292">
                {video.title}
              </h4>
            </motion.div>)}
        </div>
      </div>
    </section>;
}